import axios from "axios";
import config from "config/config";

axios.defaults.baseURL = config[process.env.REACT_APP_ENV?.toUpperCase() || "LOCAL"].API_BASE_URL;

export const VERIFY_TOKEN = `/api/v1/verify-token`;
export const GET_CUSTOMER_DATA = `/api/v1/customer`;
export const UPDATE_CUSTOMER_DATA = `/api/v1/customer`;
export const UNLINKED_CUSTOMER_ACCOUNT = `/api/v1/customer/linked-account`;
export const UPDATE_CUSTOMER_NOTIFICATION_PREFERENCES = `/api/v1/customer/notification-preferences`;

// getCustomerData
export function getCustomerAPI({ includeCredentials } = {}) {
  const url = includeCredentials
    ? `${GET_CUSTOMER_DATA}?includeCredentials=true`
    : GET_CUSTOMER_DATA;
  return axios.get(url, {
    validateStatus(status) {
      return true;
    },
  });
}

// update customer Data
export function updateCustomerAPI(data) {
  return axios.put(UPDATE_CUSTOMER_DATA, data, {
    validateStatus(status) {
      return true;
    },
  });
}

// unlinked customer account
export function unLinkedCustomerAccount(id) {
  return axios.delete(`${UNLINKED_CUSTOMER_ACCOUNT}/${id}`, {
    validateStatus(status) {
      return true;
    },
  });
}

export function saveNotificationPreferencesAPI(payload) {
  return axios.put(UPDATE_CUSTOMER_NOTIFICATION_PREFERENCES, payload, {
    validateStatus(status) {
      return true;
    },
  });
}
